import { createContext, useState } from 'react'
import PropTypes from 'prop-types'

export const ModalGalleryContext = createContext()

const ModalGalleryProvider = (props) => {
  const { children } = props

  // states
  const [caption, setCaption] = useState('')
  const [videoList, setVideoList] = useState([])
  const [currentIndex, setCurrentIndex] = useState(0)
  const [currentId, setCurrentId] = useState(false)

  // context methods
  const captureVideoList = () => {
    const idList = []
    const videoButtons = document.querySelectorAll('[data-youtubeid]')
    videoButtons.forEach((button) => {
      const isAlreadyInArray = idList.find((item) => item.youtubeId === button.dataset.youtubeid)
      if (!isAlreadyInArray) {
        idList.push({
          youtubeId: button.dataset.youtubeid,
          youtubeTitle: button.dataset.youtubetitle
        })
      }
    })
    return idList
  }

  const getCurrentIndex = (list, id) => {
    return list.indexOf(list.find((item) => item.youtubeId === id))
  }

  const setCurrentValues = (modalContext) => {
    let list = false
    let index = false
    let id = false

    list = modalContext?.modalPlaylist.length >= 1 ? modalContext.modalPlaylist : captureVideoList()
    index = modalContext?.modalPlaylist.length >= 1 ? 0 : getCurrentIndex(list, modalContext.modalId)
    id = modalContext?.modalPlaylist.length >= 1 ? modalContext.modalPlaylist[0].youtubeId : modalContext.modalId

    if (list) setVideoList(list)
    if (index) setCurrentIndex(index)
    if (id) setCurrentId(id)
  }

  return (
    <ModalGalleryContext.Provider
      value={{
        caption,
        setCaption,
        videoList,
        setVideoList,
        currentIndex,
        setCurrentIndex,
        currentId,
        setCurrentId,
        setCurrentValues
      }}
    >
      {/* eslint-disable-next-line react/prop-types */}
      {children}
    </ModalGalleryContext.Provider>
  )
}

ModalGalleryProvider.propTypes = {
  children: PropTypes.object
}

export default ModalGalleryProvider
